import { useCallback } from 'react';
import type { FormField } from '../contexts';
import { useFormDispatch } from '../contexts';

export function useFormReset(fields: FormField[]) {
  const dispatch = useFormDispatch();

  return useCallback(() => {
    dispatch({
      type: 'reset'
    });

    fields.forEach(({ id, type }) => {
      dispatch({
        type: 'changeField',
        field: { id, value: undefined, valid: true, type }
      });
    });

    dispatch({
      type: 'init',
      fields
    });
  }, [fields, dispatch]);
}
